import { useDispatch } from "react-redux";
import { EditListIcon } from "../../../../assets/images/svg/svg";
import {
  editModal,
  openModal,
  updateRendererFormState,
} from "../../../../slices/common/reducer";
import { setOemEditID } from "../../../../slices/oem/oemSlice";
import { renderStatus } from "../../../../Utils/CommonUtils";
import { Link } from "react-router-dom";

const useOemColumns = () => {
  const dispatch = useDispatch();
  const oemColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/prod/oem/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 200,
    },
    {
      header: "Logo",
      accessorKey: "media_url",
      cell: (props) => {
        const imageUrl = props?.getValue(); // Assuming media_url contains the image URL
        return imageUrl ? (
          <div className="card--list-img">
          <img
            src={imageUrl} // Display the image URL directly
            alt="OEM"
          />
          </div>
        ) : (
          "-"
        ); // If no URL is available, show a dash
      },
      size: 200,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 160,
    },
    // {
    //   header: "Action",
    //   accessorKey: "action",
    //   cell: (props) => (
    //     <div className="action-icons text-center">
    //       <span
    //         // className="btn btn-sm btn-soft-info edit-list"
    //         onClick={() => {
    //           dispatch(openModal(true));
    //           dispatch(editModal(true));
    //           dispatch(updateRendererFormState(props?.row?.original));
    //           dispatch(setOemEditID(props?.row?.original?.entityid));
    //         }}
    //       >
    //         {/* <i className="ri-pencil-fill align-bottom" /> */}
    //         <EditListIcon />
    //       </span>
    //     </div>
    //   ),
    //   meta: { align: "center" },
    //   size: 100,
    // },
  ];

  return { oemColumns };
};
export default useOemColumns;
